import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import classes from '../create-schedule/CreateSchedule.module.scss';
import styles from '../job-scheduler/JobScheduler.module.scss';
import { week, weekType } from '../../utilities/Utility';

interface WeekTxtProps {
  weeklyText: string;
}

interface WeekProps {
  selectedDays: string[];
  setSelectedDays: (arr: string[]) => void;
}

export const WeeklyCompTxt = (props: WeekTxtProps) => {
  const { weeklyText } = props;

  return (
    <div className={classes['week-align']} data-testid="weekText">
      {weeklyText}
    </div>
  );
};

export const WeeklyComp = (props: WeekProps) => {
  const { t: translate } = useTranslation();
  const { selectedDays, setSelectedDays } = props;
  const [weeks, setWeeks] = useState(week);

  useEffect(() => {
    const newArr = [...selectedDays];
    weeks.forEach((data: weekType) => {
      if (data.flag) {
        newArr.push(translate(data.name));
        setSelectedDays(newArr);
      }
    });
  }, [translate]);

  /**
   * @method handleSelectDays
   * @description handles the onclick function of weekdays by selecting and deselecting from the days array.
   * @param i
   * @param name
   */
  const handleSelectDays = (i: number, name: string) => {
    const weekArr = [...weeks];
    const newVal = [...selectedDays];
    weekArr.forEach((data: weekType) => {
      if (i === data.index) {
        weekArr[i - 1].flag = !weekArr[i - 1].flag;
        setWeeks(weekArr);
      }
    });
    if (!selectedDays.includes(translate(name))) {
      newVal.push(translate(name));
      setSelectedDays(newVal);
    }
    if (selectedDays.includes(translate(name))) {
      const spliceIndex = selectedDays.indexOf(translate(name));
      newVal.splice(spliceIndex, 1);
      setSelectedDays(newVal);
    }
  };

  return (
    <div className={styles['week-buttons']} data-testid="weekComp">
      {weeks.map((item: weekType) => (
        <div key={item.index} className={styles['week-btn']}>
          <button type="button" onClick={() => { handleSelectDays(item.index, translate(item.name)); }} className={`${item.flag ? styles.checked : styles.unchecked}`} data-testid="weekBtn">
            {item.sign}
          </button>
        </div>
      ))}
    </div>
  );
};
